import React, { useContext, useEffect, useState } from 'react'
import logo from "../../assets/images/spec-logo.png";
import { useNavigate } from 'react-router-dom'
import { Avatar, Dropdown, Typography, message } from 'antd'
import { UserOutlined, LogoutOutlined, SettingOutlined, LockOutlined } from '@ant-design/icons';
import { LoginAPI } from '../../API/LoginAPI';
import { SelectFlightModal } from '../modals/SelectFlightModal';
import { FlightModalAPI } from '../../API/FlightModalAPI';
import { ContextData } from '../../ContextData';
import EditProfile from '../modals/EditProfile';
import EditPassword from '../modals/EditPassword';
const { Text } = Typography

const items = [
    {
        label: "Edit Password",
        key: '4',
        icon: <LockOutlined />,
    },
    {
        label: "Logout",
        key: '1',
        icon: <LogoutOutlined />,
    },
    {
        label: "Update Profile",
        key: '3',
        icon: <UserOutlined />,
    },
    
]

const adminItems = [
    {
        label: "Admin Portal",
        key: '2',
        icon: <SettingOutlined />,
    },
    {
        label: "Edit Password",
        key: '4',
        icon: <LockOutlined />,
    },
    {
        label: "Logout",
        key: '1',
        icon: <LogoutOutlined />,
    },
    {
        label: "Update Profile",
        key: '3',
        icon: <UserOutlined />,
    },
]

export default function Navbar() {
    const navigate = useNavigate()
    const { userRole, setUserRole } = useContext(ContextData);
    const [messageApi, contextHolder] = message.useMessage();
    const [flightModalPopup, setFlightModalPopup] = useState(false);
    const [flightList, setFlightList] = useState()
    const [selectedFlight, setSelectedFlight] = useState(null);
    const [editProfileModal, setEditProfileModal] = useState(false);
    const [editPswdModal, setEditPswdModal] = useState(false)

    async function getRankingData() {
        await FlightModalAPI.getFlightModals()
            .then(res => {
                if (res?.data?.status === true) {
                    const arr = [{ value: null, label: '--select--' }]
                    res.data?.flight_models.forEach(ele => { arr.push({ value: ele, label: ele }) })
                    setFlightList(arr)
                    setSelectedFlight(res?.data?.selected_flight_model)
                    localStorage.setItem("flight_model", res?.data?.selected_flight_model)
                } else {
                    messageToast("error", res.data?.message)
                }
            })
            .catch(() => messageToast("error", "Internal Server Error"))
    }

    useEffect(() => {
        getRankingData()
    }, [])

    const messageToast = (type, message) => {
        messageApi.open({
            type: type,
            content: message,
            duration: 6,
        });
    };

    useEffect(() => {
        if (localStorage.getItem("userRole")) {
            setUserRole(localStorage.getItem("userRole"))
        }
    }, [])

    return (
        <>
            <div className='topnavbar_wraper_div'>
                <img src={logo} style={{ width: '120px', cursor: 'pointer' }} onClick={() => navigate("/")} alt={`img_${logo}`} />
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <div style={{ marginRight: '30px', cursor: 'pointer' }} onClick={() => setFlightModalPopup(true)}>
                        <Avatar size='default' icon={<SettingOutlined />} style={{ backgroundColor: 'transparent', color: '#000000ab' }} />
                        <Text style={{ color: '#484950', fontSize: '14px', fontWeight: 500, marginLeft: '0px', textTransform: 'capitalize' }}>{selectedFlight}</Text>
                    </div>
                    <Dropdown
                        menu={{
                            items: userRole === "admin" ? adminItems : items,
                            onClick: async (event) => {
                                switch (event.key) {
                                    case "1":
                                        const bodyData = {
                                            "token": localStorage.getItem("SWAAccessToken")
                                        }
                                        await LoginAPI.logout(bodyData)
                                            .then(res => {
                                                if (res.data.status === true) {
                                                    localStorage.setItem("SWAAccessToken", "")
                                                    localStorage.setItem("loged-user", "")
                                                    navigate("/login")
                                                } else {
                                                    message.error(res.data?.message);
                                                }
                                            })
                                            .catch(() => message.error("Internal Server Error"))
                                        break;
                                    case "2":
                                        navigate("/admin/user-management");
                                        break;
                                    case "3":
                                        setEditProfileModal(true)
                                        break;
                                    case "4":
                                        setEditPswdModal(true)
                                        break;
                                    default:
                                        break;
                                }

                            }
                        }}
                    >
                        <div style={{ cursor: 'pointer' }}>
                            <Avatar size='default' icon={<UserOutlined />} style={{ backgroundColor: '#EBEEF8', color: '#304cb2' }} />
                            <Text style={{ color: '#484950', fontSize: '14px', fontWeight: 500, marginLeft: '5px', textTransform: 'capitalize' }}>{localStorage.getItem("user-first-name")}</Text>
                        </div>
                    </Dropdown>

                </div>
            </div>
            <SelectFlightModal
                open={flightModalPopup}
                setOpen={setFlightModalPopup}
                flightModalOptions={flightList}
                selectedModal={selectedFlight}
                messageToast={messageToast}
            />
            <EditProfile open={editProfileModal} setOpen={setEditProfileModal} messageToast={messageToast} />
            <EditPassword open={editPswdModal} setOpen={setEditPswdModal} messageToast={messageToast} />
            {contextHolder}
        </>
    )
}
